var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navBar"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":_vm.$route.meta.title != '账单查询' &&
      _vm.$route.meta.title != '设备' &&
      _vm.$route.meta.title != '统计'},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }